// Audit table cells, ported from the vouchers admin. Rows are kore's
// `AuditEvent` (see kore-audit-adapter.tsx); text helpers live in summary.ts.

import { AuditActionChip } from "@pej/kore/components";
import { FormatRelativeTime } from "@pej/kore/intl";
import type { AuditEvent } from "@pej/kore/types";
import { auditActionMeta, auditTargetTypeLabel } from "./kore-audit-adapter";
import { summarizeDetails } from "./summary";

export interface AuditCellProps {
    event: AuditEvent;
}

export function TimeCell({ event }: AuditCellProps) {
    return (
        <span className="text-kore-text-muted">
            <FormatRelativeTime value={new Date(event.occurredAt)} />
        </span>
    );
}

export function ActorCell({ event }: AuditCellProps) {
    // No actor means the system acted on its own, not a failed lookup.
    const name = event.actor?.displayName ?? event.actor?.email;
    if (!name) return <span className="text-kore-text-muted italic">System</span>;
    return <span>{name}</span>;
}

export function ActionCell({ event }: AuditCellProps) {
    return <AuditActionChip event={event} actionMeta={auditActionMeta} />;
}

export function TargetTypeCell({ event }: AuditCellProps) {
    return <span className="text-kore-text-muted">{auditTargetTypeLabel(event.target.type)}</span>;
}

export function TargetCell({ event }: AuditCellProps) {
    return <span>{event.target.displayName}</span>;
}

export function DetailsCell({ event }: AuditCellProps) {
    return <span className="truncate">{summarizeDetails(event.details)}</span>;
}
